import React, { useState } from "react";
import headerImage from "../../assets/images/SIC_Header.jpeg";
import logo from "../../assets/images/SIC_Logo.webp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faBars,
  faTimes,
} from "@fortawesome/pro-regular-svg-icons";
import PrivateNav from "./PrivateNav";
import PublicNav from "./PublicNav";
import useUserAuth from "../../hooks/useUserAuth";

interface HeaderProps {
  props?: any;
}

const Header = ({ props }: HeaderProps) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const { currentUser } = useUserAuth();

  return (
    <>
      <div
        className="relative w-full h-[400px] bg-cover"
        style={{
          backgroundImage: `url(${headerImage})`,
          backgroundPosition: "50% 15%",
        }}
      >
        <div className="absolute w-full h-full left-0 right-0 flex flex-col items-center justify-center g z-50 text-white">
          <span className="text-[42px] font-extrabold">MORTGAGE NOTES</span>
          <span className="text-[24px] font-base italic ">
            ACTIVE REAL ESTATE INVESTING
          </span>
        </div>
        <div className="w-full h-full absolute top-0 left-0 right-0 bg-black opacity-50 z-0"></div>
        <div className="bg-white h-[70px] z-50 fixed top-0 left-0 right-0 flex flex-row items-center justify-between px-10">
          <div
            className="cursor-pointer"
            onClick={() =>
              (window.location.href = "https://securedinvestmentcorp.com/")
            }
          >
            <img src={logo} alt="logo" className="w-[180px] " />
          </div>

          {/* Hamburger button for mobile */}
          <button className="lg:hidden text-main-gray" onClick={toggleMenu}>
            <FontAwesomeIcon icon={isMenuOpen ? faTimes : faBars} />
          </button>

          {/* Desktop menu */}
          <div className="hidden lg:flex flex-row items-center justify-end gap-5 text-[12px] text-main-gray h-full">
            <div className="gap-2 cursor-pointer dropdown dropdown-hover h-full">
              <div
                tabIndex={0}
                role="button"
                className="flex flex-row items-center gap-2 h-full"
              >
                <span>Investments</span>
                <FontAwesomeIcon icon={faChevronDown} />
              </div>
              <ul
                tabIndex={0}
                className="dropdown-content menu bg-white border-t-2 border-[#164A7C]  z-[1] w-52  text-xs"
              >
                <li className="w-full h-full rounded-none">
                  <a href="https://securedinvestmentcorp.com/secured-investment-high-yield-fund-ii/">
                    Fund II
                  </a>
                </li>
                <li className="w-full h-full rounded-none">
                  <a href="https://securedinvestmentcorp.com/circle-of-wealth-fund-iii/">
                    Fund III
                  </a>
                </li>
                <li className="w-full h-full rounded-none">
                  <a href="https://securedinvestmentcorp.com/fixed-income-fund-v/">
                    Fund V
                  </a>
                </li>
                <li className="w-full h-full rounded-none">
                  <a href="https://notes.securedinvestmentcorp.com">
                    Mortgage Notes
                  </a>
                </li>
                <li className="w-full h-full rounded-none">
                  <a href="https://cogorealty.com/turn-key-investments">
                    Turn Key Rentals
                  </a>
                </li>
              </ul>
            </div>
            <a
              href="https://securedinvestmentcorp.com/what-we-do/"
              className=""
            >
              What We Do
            </a>
            <a href="https://securedinvestmentcorp.com/why-us/" className="">
              Why Us
            </a>
            <a
              href="https://securedinvestmentcorp.com/preferred-custodians/"
              className=""
            >
              Preferred Custodians
            </a>
            <div className="gap-2 cursor-pointer dropdown dropdown-hover h-full">
              <div
                tabIndex={0}
                role="button"
                className="flex flex-row items-center gap-2 h-full"
              >
                <span>In The News</span>
                <FontAwesomeIcon icon={faChevronDown} />
              </div>
              <ul
                tabIndex={0}
                className="dropdown-content menu bg-white border-t-2 border-[#164A7C]  z-[1] w-52  text-xs"
              >
                <li className="w-full h-full rounded-none">
                  <a href="https://securedinvestmentcorp.com/blog/">Blog</a>
                </li>
                <li>
                  <a href="https://securedinvestmentcorp.com/webinars/">
                    Investor Training Series
                  </a>
                </li>
                <li>
                  <a href="https://securedinvestmentcorp.com/secured-investment-corp-in-the-news/">
                    Podcasts
                  </a>
                </li>
                <li>
                  <a href="https://securedinvestmentcorp.com/category/the-market-report/">
                    The Market Report
                  </a>
                </li>
              </ul>
            </div>
            <a
              href="https://securedinvestmentcorp.com/positions-available/"
              className=""
            >
              Careers
            </a>
            <a
              href="https://hesthesolution.com/bibles/?__hstc=59566066.cf3d398fa9304e2f9c807b43c19fdd98.1726004837028.1728066529045.1728321358069.31&__hssc=59566066.6.1728321358069&__hsfp=3134180813"
              className=""
            >
              Request Free Bible
            </a>
            {currentUser ? <PrivateNav /> : <PublicNav />}
          </div>

          {/* Mobile menu */}
          <div
            className={`lg:hidden fixed top-[70px] left-0 right-0 bg-white transition-all duration-300 ease-in-out text-main-gray ${
              isMenuOpen
                ? "max-h-screen opacity-100"
                : "max-h-0 opacity-0 overflow-hidden"
            }`}
          >
            <div className="flex flex-col items-start p-4 space-y-4">
              {/* Mobile menu items */}
              <div className="dropdown w-full">
                <div
                  tabIndex={0}
                  className="flex justify-between items-center w-full"
                >
                  <span>Investments</span>
                  <FontAwesomeIcon icon={faChevronDown} />
                </div>
                <ul
                  tabIndex={0}
                  className="dropdown-content menu bg-white w-full mt-2 text-xs"
                >
                  <li>
                    <a href="https://securedinvestmentcorp.com/secured-investment-high-yield-fund-ii/">
                      Fund II
                    </a>
                  </li>
                  <li>
                    <a href="https://securedinvestmentcorp.com/circle-of-wealth-fund-iii/">
                      Fund III
                    </a>
                  </li>
                  <li>
                    <a href="https://securedinvestmentcorp.com/fixed-income-fund-v/">
                      Fund V
                    </a>
                  </li>
                  <li>
                    <a href="https://notes.securedinvestmentcorp.com">
                      Mortgage Notes
                    </a>
                  </li>
                  <li>
                    <a href="https://cogorealty.com/turn-key-investments">
                      Turn Key Rentals
                    </a>
                  </li>
                </ul>
              </div>
              <a href="https://securedinvestmentcorp.com/what-we-do/">
                What We Do
              </a>
              <a href="https://securedinvestmentcorp.com/why-us/">Why Us</a>
              <a href="https://securedinvestmentcorp.com/preferred-custodians/">
                Preferred Custodians
              </a>
              <div className="dropdown w-full">
                <div
                  tabIndex={0}
                  className="flex justify-between items-center w-full"
                >
                  <span>In The News</span>
                  <FontAwesomeIcon icon={faChevronDown} />
                </div>
                <ul
                  tabIndex={0}
                  className="dropdown-content menu bg-white w-full mt-2 text-xs"
                >
                  <li>
                    <a href="https://securedinvestmentcorp.com/blog/">Blog</a>
                  </li>
                  <li>
                    <a href="https://securedinvestmentcorp.com/webinars/">
                      Investor Training Series
                    </a>
                  </li>
                  <li>
                    <a href="https://securedinvestmentcorp.com/secured-investment-corp-in-the-news/">
                      Podcasts
                    </a>
                  </li>
                  <li>
                    <a href="https://securedinvestmentcorp.com/category/the-market-report/">
                      The Market Report
                    </a>
                  </li>
                </ul>
              </div>
              <a href="https://securedinvestmentcorp.com/positions-available/">
                Careers
              </a>
              <a href="https://hesthesolution.com/bibles/?__hstc=59566066.cf3d398fa9304e2f9c807b43c19fdd98.1726004837028.1728066529045.1728321358069.31&__hssc=59566066.6.1728321358069&__hsfp=3134180813">
                Request Free Bible
              </a>
              <div className="z-50 h-full">
                <div className="px-2">
                  {currentUser ? <PrivateNav /> : <PublicNav />}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="absolute bottom-0 left-0 w-full">
          <div className="w-full h-12 bg-white z-20"></div>
        </div>
      </div>
    </>
  );
};

export default Header;
